<template>
    <div id="icon-description-section" class="pt-7 pb-7 mt-7 bg-danger parallax" data-speed="0.1" data-initial-offset="-180" style="overflow: hidden">
        <div class="container parallax-item">
            <div class="row text-center">
                <div class="col-md-4">
                    <span class="icon-bullet-icon lg shadow-diffused"><div class="fa fa-cog"></div></span>
                    <div class="text-white mt-3 mb-5 display-4">Easy to use</div>
                </div>
                <div class="col-md-4">
                    <span class="icon-bullet-icon lg shadow-diffused"><div class="fa fa-heart"></div></span>
                    <div class="text-white mt-3 mb-5 display-4">Flexible and Convenient</div>
                </div>
                <div class="col-md-4">
                    <span class="icon-bullet-icon lg shadow-diffused"><div class="fa fa-handshake"></div></span>
                    <div class="text-white mt-3 mb-5 display-4">Credible</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "IconDescriptionSection",
}
</script>